import { useFragmentsViewCapture } from '@app/modules/fragments/hooks/useFragmentsViewCapture';
import { downloadFile } from '@mi-front/core';
import AudioFileIcon from '@mui/icons-material/AudioFile';
import VideoFileIcon from '@mui/icons-material/VideoFile';
import { Button } from '@mui/material';
import { defineMessage, useIntl } from 'react-intl';

const downloadMediaMessage = defineMessage({
  id: 'fragments.export.downloadMedia',
  defaultMessage: 'Descargar {type}',
});

/** Label for source audio on video fragments (typically AAC next to the MP3 alternate). */
const downloadMediaAudioAacMessage = defineMessage({
  id: 'fragments.export.downloadMediaAudioAac',
  defaultMessage: 'Descargar {type} (aac)',
});

interface Props {
  readonly mediaUrl: string;
  readonly mediaType: 'AUDIO' | 'VIDEO';
  /** When true with `mediaType` audio, appends the `(aac)` codec hint to the label (video fragments). */
  readonly showExtension?: boolean;
}

export function ForceDownloadMediaBtn({ mediaUrl, mediaType, showExtension = false }: Props) {
  const { $t, formatMessage } = useIntl();
  const { downloadMedia } = useFragmentsViewCapture();

  function handleClick() {
    downloadMedia({ mediaType });
    downloadFile(mediaUrl, false);
  }

  const typeLabelAudio = $t({ id: 'common.audio', defaultMessage: 'audio' });
  const typeLabelVideo = $t({ id: 'common.video', defaultMessage: 'video' });

  const label =
    mediaType === 'AUDIO' && showExtension
      ? formatMessage(downloadMediaAudioAacMessage, { type: typeLabelAudio })
      : formatMessage(downloadMediaMessage, {
          type: mediaType === 'AUDIO' ? typeLabelAudio : typeLabelVideo,
        });

  return (
    <Button
      color="secondary"
      variant="outlined"
      size="small"
      onClick={handleClick}
      startIcon={mediaType === 'AUDIO' ? <AudioFileIcon /> : <VideoFileIcon />}
    >
      {label}
    </Button>
  );
}
